import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import Dropzone from 'react-dropzone';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Service from '../../services/role.service';
import * as componentActions from '../../redux/actions/roles';
import SimpleSelect from '../../components/select/simple';
import { browserHistory } from '../../helpers/history';
import Title from '../../components/title-name';
import MyTransferList from '../../components/transfer-list/transferlist';

import Footer from '../../components/footer';

import { FormattedMessage,injectIntl } from 'react-intl';


class RoleEdit extends Component {

  constructor(props) {
    super(props);
            const { userSession,roles } = this.props;
   
    //        console.log(roles);
    this.globalAdm = false;
    this.isClient = true;
    if(userSession.user.userrole == null){
      Api.logoff();
    }

    if(!roles || (roles && !roles.role)) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/calleds`
    }

    userSession.user.userrole.map((item, key) => {
            if(item.role.roletype !=3){
                this.isClient = false;
            }
            if(item.role.roletype ==0){
              this.globalAdm =true;
            }
        }
    );

 
    this.initialState = {
      UpdatedUser: userSession.user.id,
      id: roles.role.id,
      name : roles.role.name == null ? '' : roles.role.name , 
      displayname : roles.role.displayname == null ? '' : roles.role.displayname , 
      description : roles.role.description == null ? '' : roles.role.description , 
      RoleType : roles.role.roletype, 
      Permissions: roles.role.permissionroles.map(item => { return item.permission }),
      system : roles.role.system,
     };      
     
     
    this.state = {
      role: this.initialState,

      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      // Perfil base é fixo depois de criado. Só o legado gravado como Customized (5) pode ser
      // definido aqui, uma vez, dentro da alçada de quem edita (mesma lista do cadastro).
      RoleTypeList: this.buildRoleTypeList(userSession, props.intl, roles.role.roletype),
      PermissionsList: [],
      
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
  }



  buildRoleTypeList(userSession, intl, currentType) {
    const tr = (id, fallback) => { try { return intl.formatMessage({ id }); } catch (e) { return fallback; } };
    const all = [
      { id: 0, name: tr('role.type.global', 'Administrador do Sistema') },
      { id: 1, name: tr('role.type.administrator', 'Administrador de Organizações') },
      { id: 4, name: tr('role.type.coordenator', 'Coordenador de Organizações') },
      { id: 2, name: tr('role.type.technical', 'Técnico') },
      { id: 3, name: tr('role.type.client', 'Cliente') },
      { id: 5, name: tr('role.type.customized', 'Personalizado (defina o perfil base)') },
      { id: 6, name: 'Chatbot' }, { id: 7, name: 'System' },
    ];
    if (currentType !== 5) return all;
    const types = (userSession.user.userrole || []).map((u) => u.role.roletype);
    const isGlobal = types.indexOf(0) > -1; const isAdm = isGlobal || types.indexOf(1) > -1; const isCoord = isAdm || types.indexOf(4) > -1;
    return all.filter((o) => o.id === 5 || (o.id === 0 && isGlobal) || (o.id === 1 && isAdm) || ((o.id === 4 || o.id === 2 || o.id === 3) && isCoord));
  }

  componentWillReceiveProps(nextProps){
                        if(nextProps.location.state === "reload"){
                            this.componentDidMount();
                        }
                    }    

                    componentDidMount() {
    this.getPermissionsExceptRole();
    //this.getPermissionsByRole();
    console.log(this.state.role);

  };


  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      role: {
        ...prevState.role,
        [name]: value
      }
    }));
  };

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    let data = new FormData();


      if (this.isClient) {
        this.setState(prevState => ({
          role: {
            ...prevState.role,
          }
        }));
      } else {
        this.setState(prevState => ({
          role: {
            ...prevState.role,
          }
        }));
      }


      for (let key in this.state.role) {
        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1) {
          data.append(key, moment(this.state.role[key]).format('YYYY/MM/DD HH:mm:ss'));
        } 
        else if (key.toString().toLowerCase().indexOf('roletype') > -1 ) {
          data.append(key, this.state.role[key]);
        }
        else if (key.toString().toLowerCase().indexOf('permissions') > -1) { 
            data.append(key, this.state.role[key].map(item => {
              return item.id
            }));
        }        
        else {
          data.append(key, this.state.role[key]);
        }
      }

      this.state.files.forEach(file => data.append('filesUpload', file));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
        Api.put('/roles', data, config)

        .then(result => {
          if (result.data.success) {
            const intl = this.props.intl;

        const formattedList = result.data.data;

            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({id:"edit.success"}),
              files: []
            });
        this.props.addCurrent(formattedList);
        this.componentDidMount();
 
          }
          else{
            const intl = this.props.intl;

            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage:  result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({id:"process.error"})
            });

          }
        })
        .catch(err => {
          const intl = this.props.intl;

          if(err.response && err.response.data && err.response.data.errors){
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({id:"process.error"})
            });
          }
          else{
            const intl = this.props.intl;

            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: intl.formatMessage({id:"process.error"})
            });
          }
        });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState(prevState => ({
      role: {
        ...prevState.role,
        [stateName]: value
      }
    }));
 
    this.setState({ loading: false });

  };

  
  async getPermissionsByRole(){
    this.setState({ loading: true });
    var result = await Service.getPermissionsByRole(this.state.role.id);
      if (result.success) {
        this.setState({ loading: false, Permissions: result.data });
       /*
        this.setState(prevState => ({
          loading: false,
          role: {
            ...prevState.role,
            Permissions : result.data,
          }
        }));
       */
                      
      } else {
        const intl = this.props.intl;

        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
        Api.kickoff(result);
      }
  };

  async getPermissionsExceptRole(){
    this.setState({ loading: true });
    var result = await Service.getPermissionsExceptRole(this.state.role.id);
      if (result.success) {
        
        this.setState({ loading: false, PermissionsList: result.data });
                      
      } else {
        const intl = this.props.intl;
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        });
        Api.kickoff(result);
      }
  };
    

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

    render() {
    const { classes, headerMenu, actionsHeaderMenu, roles } = this.props;
    const { role } = this.state;
    const intl = this.props.intl;

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

     return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                    <Button variant='outlined' color='primary'  onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
                {<FormattedMessage id="edit.item" />}
                <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <SimpleSelect label={intl.formatMessage({id:"role.base"})} options={this.state.RoleTypeList} name='roletype' stateName='RoleType' changeSelect={this.changeValues} selected={role.RoleType} disabled={this.state.role.system == true || this.initialState.RoleType !== 5} />
                      <Typography variant="caption" style={{ color: '#888' }}>{intl.formatMessage({id: this.initialState.RoleType === 5 ? "role.base.legacy" : "role.base.help"})}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField fullWidth label={intl.formatMessage({id:"name"})} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={role.name} required />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField fullWidth label={intl.formatMessage({id:"display.name"})} autoComplete='fname' variant='outlined' name='displayname' onChange={this.handleInputChange} value={role.displayname}  />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField fullWidth label={intl.formatMessage({id:"description"})} multiline rows={6}  autoComplete='fname' variant='outlined' name='description' onChange={this.handleInputChange} value={role.description}  />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <MyTransferList name='permissions' changeSelect={this.changeValues} label={intl.formatMessage({id:"functionalities"})}  options={this.state.PermissionsList} stateName="Permissions"  selected={role.Permissions} />
                    </Grid>

              
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                  <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                  <Grid item xs={12} sm={4}   >
                    <Button
                      disabled={this.state.role.system == true} 
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='primary'
                      className={classes.submit}
                    >
                      {<FormattedMessage id="save" />}
                    </Button>
                  </Grid>
                </Grid>
                </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />                    
      </div>
    );
  }
}
RoleEdit.propTypes = {
                    classes: PropTypes.object.isRequired
                };
                const mapStateToProps = state => ({
                  actionsHeaderMenu: state.actionsHeaderMenu,
                    headerMenu: state.headerMenu,
                    userSession: state.userSession,
                    roles: state.roles
                });
                const mapDispatchToProps = dispatch =>
                    bindActionCreators(componentActions, dispatch);

            export default injectIntl(connect(mapStateToProps,mapDispatchToProps)(withStyles(Styles)(RoleEdit)));
